import { type ReactNode, useState } from "react";
import Modal, { type ModalProps } from "../Modal";

export type ModalTriggerProps = Omit<ModalProps, "isShow"> & {
  renderAction: (open: () => void) => ReactNode;
  children: ReactNode;
  renderFooterContent?: (close: () => void) => ReactNode;
};

export const ModalTrigger = ({
  renderAction,
  children,
  onClose,
  renderFooterContent,
  ...modalProps
}: ModalTriggerProps) => {
  const [isOpened, setIsOpened] = useState(false);

  const handleClose = () => {
    setIsOpened(false);
    onClose?.();
  };

  return (
    <>
      {renderAction(() => setIsOpened(true))}
      <Modal
        isShow={isOpened}
        onClose={handleClose}
        footerContent={renderFooterContent?.(handleClose)}
        {...modalProps}
      >
        <>{children}</>
      </Modal>
    </>
  );
};
